<template>
  <scout-form
    :is-modified="!!from || !!to"
    label="送信日"
    half
  >
    <term-select
      :from="from"
      :to="to"
      no-option
      @update:from="$emit('update:from', $event)"
      @update:to="$emit('update:to', $event)"
    />
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import TermSelect from '@/components/atoms/TermSelect'

export default {
  components: {
    ScoutForm,
    TermSelect
  },
  props: {
    from: {
      required: true,
      type: String
    },
    to: {
      required: true,
      type: String
    }
  }
}
</script>
